import { Link, useNavigate } from 'react-router-dom';
import { Typography } from '@/shared/ui/Typography';
import { EMPTY_PHOTO_BASE64 } from '@/shared/const';
import Logo from '@/shared/assets/lk/logo.svg?react';
import { SkeletonWrapper } from '@/features/Skeleton';
import { LogoutButton } from '@/features/LK/LogoutButton';
import { useUserPhoto, useUserStore } from '@/entities/User';
import { getUserName } from '@/shared/lib/utils/getUserName';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import NoProfilePhoto from '@/shared/assets/icons/noProfile.svg?react';
import cls from './LKHeader.module.scss';

type Props = {
    hideUserControls?: boolean;
};

export const LKHeader = ({ hideUserControls = false }: Props) => {
    const {
        userData: { firstName, secondName },
        isUserLoading,
        isUserDataLoading,
    } = useUserStore();

    const { data: photo, isLoading: isUserPhotoLoading, isError } = useUserPhoto();

    const navigate = useNavigate();

    const onProfileClick = () => {
        navigate('/lk/profile');
    };

    const userName = getUserName({ name: firstName, surname: secondName });

    const width = useResize();

    const hasPhoto = photo && photo !== EMPTY_PHOTO_BASE64 && !isError;

    return (
        <div className={cls.container}>
            {width > 767 && (
                <>
                    <div className={cls.logo}>
                        <Link to="https://sberbank-insurance.ru/">
                            <Logo className={cls.logoIcon} />
                        </Link>
                    </div>
                    <div className={cls.phones}>
                        <Link to="tel:900">900</Link>
                        <Link to="tel:+7 495 500-55-50">+7 495 500-55-50</Link>
                    </div>
                </>
            )}
            {!hideUserControls && (
                <>
                    <SkeletonWrapper
                        width="120px"
                        height="34px"
                        isLoading={isUserLoading || isUserDataLoading || isUserPhotoLoading}
                    >
                        <button className={cls.profile} type="button" onClick={onProfileClick}>
                            {hasPhoto ? (
                                <img className={cls.photo} src={photo} alt="user_profile" />
                            ) : (
                                <NoProfilePhoto width={34} height={34} />
                            )}
                            <Typography as="p" variant="text_16_bold">
                                {userName}
                            </Typography>
                        </button>
                        <LogoutButton className={cls.logout} />
                    </SkeletonWrapper>
                </>
            )}
        </div>
    );
};
